import type { Locale } from "../i18n";

const copy = {
	ja: {
		dropTitle: "ここに3Dをドロップ。",
		dropHint: "画面のどこに置いても、アップロードの準備へ。",
		choose: "アップロードをはじめる",
		formats: "PLY / SPZ / SOG / HTML · 最大2GB",
		release: "離して、アップロードへ。",
		releaseHint: "ファイルを受け取って、共有内容の設定へ進みます。",
		busy: "いまのアップロードが終わってからどうぞ。",
		oneFile: "ファイルは1つずつドロップしてください。",
		closeEditor: "編集中の画面を閉じてから、ファイルをドロップしてください。",
		dismiss: "閉じる",
		ready: "アップロードの準備ができました",
		replace: "別のファイルも、この画面へドロップできます。",
		transfer: "転送",
		save: "保存",
		link: "リンク",
		remaining: "残り約",
		seconds: "秒",
		minutes: "分",
	},
	en: {
		dropTitle: "Drop your 3D here.",
		dropHint: "Anywhere on the page. Straight to your upload.",
		choose: "Start uploading",
		formats: "PLY / SPZ / SOG / HTML · Up to 2 GB",
		release: "Let go. Let's upload.",
		releaseHint: "Your file goes straight to the sharing settings.",
		busy: "Let the current upload finish before dropping another file.",
		oneFile: "Drop one file at a time.",
		closeEditor: "Close the current editor before dropping a file.",
		dismiss: "Dismiss",
		ready: "Ready to upload",
		replace: "Drop another file anywhere on this page to replace it.",
		transfer: "Transfer",
		save: "Save",
		link: "Link",
		remaining: "About",
		seconds: "s left",
		minutes: "min left",
	},
} as const;

export const getUploadExperienceCopy = (locale: Locale) => copy[locale];
